import { render } from "./ModalErrorAI.vue?vue&type=template&id=b99b699a&scoped=true"
import script from "./ModalErrorAI.vue?vue&type=script&lang=js"
export * from "./ModalErrorAI.vue?vue&type=script&lang=js"

import "./ModalErrorAI.vue?vue&type=style&index=0&id=b99b699a&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99b699a"]])

export default __exports__